import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";

const Header = () => {
  const [open, setOpen] = useState(false);
  const [expended, setExpended] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const [isTermsOpen, setIsTermsOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    setIsTermsOpen(false);
  };



  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const dropdownRef = useRef(null);

  return (
    <>
      <div className="xl:flex w-full justify-center mainHeader h-24 bg-white fixed top-0 z-20 hidden">
        <div className="px-[70px] w-full border-b-[1px] border-[#F5F5F5]">
          <header className="flex justify-between relative py-6 mx-auto items-center h-full w-full border-b border-white/10">
            <div className="flex gap-24 items-center">
              <Link to="/" aria-label="logo-home">
                <img data-aos="fade"
                  src="assets/images/brand_logo.png"
                  alt=""
                  style={{ width: "200px" }}
                />
              </Link>
            </div>
            <ul className="flex gap-10 text-main-black text-base leading-5 font-medium font-inter h-fit items-center">
              <li data-aos="fade">
                <Link
                  className="home-two-nav-item no-underline text-black pb-[1px] leading-5 font-inter relative delay-200 hover:text-[#1D109E] before:border-[#1D109E]"
                  to="/"
                >
                  Home
                </Link>
              </li>
              <li data-aos="fade">
                <Link
                  className="home-two-nav-item no-underline text-black pb-[1px] leading-5 font-inter relative delay-200 hover:text-[#1D109E] before:border-[#1D109E]"
                  to="/plans"
                >
                  Plans
                </Link>
              </li>
              <li data-aos="fade" className="group relative">
                <div className="home-two-nav-item no-underline text-black pb-[1px] leading-5 font-inter relative delay-200 hover:text-[#1D109E] before:border-[#1D109E] flex gap-2 items-center">
                  Terms &amp; Policies
                  <svg
                    className="transition-all duration-300 group-hover:rotate-180"
                    width={10}
                    height={10}
                    viewBox="0 0 19 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2 2L9.5 8L17 2"
                      stroke="currentColor"
                      strokeWidth={3}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                <div className="absolute px-2 -left-7 h-0 group-hover:h-[360px] overflow-hidden top-5 transition-all duration-700">
                  <ul className="max-h-fit min-w-[300px] bg-white mt-8 shadow-card-sm transition-all duration-300 overflow-hidden px-5 top-20 pb-4 rounded-b-md">
                    <li className="relative py-1">
                      <Link
                        className="home-two-nav-item no-underline leading-5 relative text-black hover:text-[#1D109E] w-fit before:border-[#1D109E]"
                        to="/term-of-use"
                      >
                        Term Of Use
                      </Link>
                    </li>
                    <li className="relative py-1">
                      <Link
                        className="home-two-nav-item leading-5 relative text-black hover:text-[#1D109E] w-fit before:border-[#1D109E]"
                        to="/shipping-delivery-policy"
                      >
                        Shipping &amp; Delivery Policy
                      </Link>
                    </li>
                    <li className="relative py-1">
                      <Link
                        className="home-two-nav-item leading-5 relative text-black hover:text-[#1D109E] w-fit before:border-[#1D109E]"
                        to="/privacy-policy"
                      >
                        Privacy Policy
                      </Link>
                    </li>
                    <li className="relative py-1">
                      <Link
                        className="home-two-nav-item leading-5 relative text-black hover:text-[#1D109E] w-fit before:border-[#1D109E]"
                        to="/cancellation-policy"
                      >
                        Cancellation Policy
                      </Link>
                    </li>
                  </ul>
                </div>
              </li>
              <li data-aos="fade">
                <Link
                  to="/contact"
                  className="home-two-nav-item  text-black pb-[1px] leading-5 font-inter relative delay-200 hover:text-[#1D109E] before:border-[#1D109E]"
                >
                  Contact
                </Link>
              </li>
            </ul>


            <div>
              <li data-aos="fade" className="group relative list-none">
                <Link href="#" className="home-two-btn-bg py-3 group bg-[#1D109E]">
                  <span className="text-base flex gap-4 items-center text-white group-hover:text-[#1D109E] transition-all duration-300 font-semibold font-inter relative z-10">
                    Login
                    <i className="fa-solid fa-arrow-right" />
                  </span>
                </Link>
                <div className="absolute px-2 mt-2 -left-7 h-0 group-hover:h-[360px] overflow-hidden top-5 transition-all duration-700">
                  <ul className="max-h-fit min-w-[200px] bg-white mt-8 border-1 shadow transition-all duration-300 overflow-hidden px-5 top-20 py-4 rounded-md">
                    <li className="mb-2">
                      <Link to="/login.html" target="_blank">Customer Login</Link>
                    </li>
                    <li className="mb-2">
                      <Link to="https://portal.truvanaopd.com/" target="_blank">Leader Login</Link>
                    </li>
                    <li>
                      <Link to="https://portal.truvanaopd.com/" target="_blank">Agent Login</Link>
                    </li>
                  </ul>
                </div>
              </li>
            </div>
          </header>
        </div>
      </div>

      <header className="flex xl:hidden flex-col relative">
        <img
          src="assets/images/home-three/hero/header-shadow.svg"
          alt=""
          className="absolute bottom-10 z-30 anim-light-shadow"
        />
        <div className="h-[100px] bg-white flex items-center justify-between fixed top-0 left-0 z-50 w-full px-2.5 border-b-[1px] border-[#e8e8e8]">
          <a href="/">
            <img
              data-aos="fade"
              src="assets/images/brand_logo.png"
              alt="logo"
              style={{ width: "200px" }}
            />
          </a>
          <button
            aria-label="mobile-Menu"
            className="text-black text-48 w-6 h-6 toggle_nav_menu"
            id="mobile_nav_toggle_menu"
            onClick={toggleMenu}
          >
            {!isMenuOpen ? (
              <svg
                className="pointer-events-none transition-all duration-300 text-black"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 448 512"
              >
                <path
                  fill="#000000"
                  d="M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"
                />
              </svg>
            ) : (
              <svg
                class="pointer-events-none transition-all duration-300"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 384 512"
              >
                <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"></path>
              </svg>
            )}
          </button>
        </div>
        <div className="transition-all duration-300" >
          <div
            className={`fixed top-[100px] pr-[30px] h-screen w-full overflow-y-scroll bg-white z-50 transition-all duration-300 ${isMenuOpen ? "left-0" : "-left-full"
              }`}
          >
            <div className="flex gap-28 flex-col pl-5 pt-5">
              <ul className="flex gap-5 flex-col text-black text-base leading-5 font-medium font-inter">
                <li>
                  <Link
                    className="home-two-nav-item no-underline text-black pb-[1px] leading-5 font-inter relative delay-200 hover:text-[#1D109E] before:border-[#1D109E]"
                    to="/" onClick={toggleMenu}
                  >
                    Home
                  </Link>
                </li>
                <li>
                  <Link
                    className="home-two-nav-item no-underline text-black pb-[1px] leading-5 font-inter relative delay-200 hover:text-[#1D109E] before:border-[#1D109E]"
                    to="/plans" onClick={toggleMenu}
                  >
                    Plans
                  </Link>
                </li>
                <li className="group relative">
                  <div onClick={() => setIsTermsOpen(!isTermsOpen)} className="home-two-nav-item no-underline text-black pb-[1px] leading-5 font-inter relative delay-200 hover:text-[#1D109E] before:border-[#1D109E] flex gap-2 !w-fit items-center">
                    Terms &amp; Policies
                    <svg
                      className={`transition-all duration-300  ${isTermsOpen ? 'rotate-180 transition-all' : 'transition-all'}`}
                      width={10}
                      height={10}
                      viewBox="0 0 19 10"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M2 2L9.5 8L17 2"
                        stroke="currentColor"
                        strokeWidth={3}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  {isTermsOpen && (
                    <ul className="bg-[#f6f6f6] px-4 py-2 my-2 rounded-lg">
                      <li className="relative py-1">
                        <Link
                          className="home-two-nav-item no-underline leading-5 relative text-black hover:text-[#1D109E] w-fitbefore:border-[#1D109E]"
                          to="/term-of-use" onClick={toggleMenu}
                        >
                          Term Of Use
                        </Link>
                      </li>
                      <li className="relative py-1">
                        <Link
                          className="home-two-nav-item leading-5 relative text-black hover:text-[#1D109E] w-fitbefore:border-[#1D109E]"
                          to="/shipping-delivery-policy" onClick={toggleMenu}
                        >
                          Shipping &amp; Delivery Policy
                        </Link>
                      </li>
                      <li className="relative py-1">
                        <Link
                          className="home-two-nav-item leading-5 relative text-black hover:text-[#1D109E] w-fitbefore:border-[#1D109E]"
                          to="/privacy-policy" onClick={toggleMenu}
                        >
                          Privacy Policy
                        </Link>
                      </li>
                      <li className="relative py-1">
                        <Link
                          className="home-two-nav-item leading-5 relative text-black hover:text-[#1D109E] w-fitbefore:border-[#1D109E]"
                          to="/cancellation-policy" onClick={toggleMenu}
                        >
                          Cancellation Policy
                        </Link>
                      </li>
                    </ul>
                  )}
                </li>
                <li>
                  <Link
                    to="/contact" onClick={toggleMenu}
                    className="home-two-nav-item text-black pb-[1px] leading-5 font-inter relative delay-200 hover:text-[#1D109E] before:border-[#1D109E]"
                  >
                    Contact
                  </Link>
                </li>
                <li>
                  <Link to="/login.html" target="_blank" className="flex justify-between items-center">
                    Customer Login
                    <svg
                      className="w-6 h-6 ml-8 -mr-2"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                        d="M13 9l3 3m0 0l-3 3m3-3H8m13 0a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                  </Link>
                </li>
                <li>
                  <Link to="https://portal.truvanaopd.com/" target="_blank" className="flex justify-between items-center">
                    Leader Login
                    <svg
                      className="w-6 h-6 ml-8 -mr-2"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                        d="M13 9l3 3m0 0l-3 3m3-3H8m13 0a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                  </Link>
                </li>
                <li>
                  <Link to="https://portal.truvanaopd.com/" target="_blank" className="flex justify-between items-center">
                    Agent Login
                    <svg
                      className="w-6 h-6 ml-8 -mr-2"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                        d="M13 9l3 3m0 0l-3 3m3-3H8m13 0a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
